// extracted by mini-css-extract-plugin
module.exports = {"uploadFilesButton":"uploadFilesButton__2nf7P","fileInput":"fileInput__vvY5T"};